import { Box, Tooltip, Typography } from '@mui/material';

import { ZoneLocationIcon } from '~/components/Icon/ZoneLocationIcon';
import { I18n } from '~/i18n';

import { getZoneIdentifier, getZoneTag, PropsWithSx } from '../../../../utils';
import Icon from '../../../Icon';
import { Zone } from '../../types';

interface ZoneStatusProps {
  zone: Zone;
  zoneId?: string;
}

export const ZoneStatusHeader = ({ zone }: ZoneStatusProps) =>
  zone?.status?.toLowerCase() === 'normal' ? (
    <>
      <ZoneLocationIcon role="img" aria-hidden="true" />
      <Typography
        variant="body1"
        sx={{ fontWeight: 'bold' }}
        textTransform="uppercase"
      >
        {I18n.t('myZones.selectedZone')}
      </Typography>
    </>
  ) : (
    <>
      <Icon size={20} color={zone?.statusColor} name={'StatusDot'} />
      <Typography variant="body1" fontWeight={'600'}>
        {zone?.status}
      </Typography>
    </>
  );

export const ZoneStatus = ({
  zone,
  zoneId,
  sx,
  ...rest
}: PropsWithSx<ZoneStatusProps>) => {
  return zone?.status?.toLowerCase() === 'normal' ? (
    <Typography variant="body2">
      <b>{getZoneTag(zone?.layerName, I18n.t)}: </b>
      <Box
        component="span"
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          flexShrink: 1,
          minWidth: 0,
        }}
      >
        {getZoneIdentifier({
          layerName: zone?.layerName,
          identifier: zone.identifier,
        })}
      </Box>
    </Typography>
  ) : (
    <Tooltip title={zone?.statusReason}>
      <Typography
        variant="body2"
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          WebkitLineClamp: '2',
          WebkitBoxOrient: 'vertical',
        }}
      >
        {zone?.statusReason}
      </Typography>
    </Tooltip>
  );
};
